<template>
  <div class="h5Prorram">
    <van-nav-bar>
      <van-button slot="left" icon="arrow-left" size="small" @click="onClickLeft" color="#006EFF"/>
    </van-nav-bar>
    <div class="h5Prorram-content">
      <router-view></router-view>
    </div>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="search" @click="goto('/h5Prorram/production')">{{$t('append_field.my_apps')}}</van-tabbar-item>
      <van-tabbar-item icon="home-o" @click="goto('/h5Prorram/template')">{{$t('append_field.template_center')}}</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "h5Prorram",
  data() {
    return {
      active: 0
    }
  },
  mounted() {
    this.active = 0
  },
  methods: {
    goto(url) {
      if (!window.location.hash.includes(url)) {
        this.$router.replace(url)
      }
    },
    onClickLeft() {
      this.$router.replace('/program')
    }
  }
}
</script>

<style lang="scss">
.h5Prorram {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .van-button--small {
    min-width: 10px !important;
    .van-icon{
      color: white;
    }
  }
  .h5Prorram-content {
    height: calc(100% - 97px);
  }

}

.van-dialog__footer--buttons {
  justify-content: flex-end;
  border: none;
  padding: 0 20px 20px 20px;

  .van-button {
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    width: 60px;
    flex: none;
    margin: 0 0 0 10px;
    border-radius: 5px;
  }

  .van-dialog__cancel {
    border: 1px solid #e41f19;
    color: #e41f19;
  }

  .van-dialog__cancel:active {
    background: #fff;
    border: 1px solid #e41f19;
  }

  .van-dialog__confirm {
    color: #fff;
    background: #006EFF;
  }

  .van-dialog__confirm:active {
    background: #006EFF;
  }

}
</style>
